import React from 'react'

import {ReactComponent as Minus} from '../../../../images/main/minus_usefulInfo.svg'
import {ReactComponent as Plus} from '../../../../images/main/plus_usefulInfo.svg'

import styles from './styles.module.scss'

const AskAndQuestions = () => {
  const [activeField, setActiveField] = React.useState(0)
  return (
    <div className={styles.wrapper}>
      <div className={styles.left}>
        <div>
          <p className={styles.title}>
            И ещё немного о программе
          </p>
        </div>
      </div>
      <div className={styles.right}>
        <p className={styles.title}>Вопросы и ответы</p>
        <div className={styles.right_item}>
          <div className={styles.right_item_questions}>
            <p
              onClick={() => (activeField ? setActiveField(null) : setActiveField(1))}
              className={
                activeField === 2 || activeField === 3 || activeField === 4 || activeField === 5
                  ? styles.questions_disable
                  : styles.questions
              }
            >
              Как пройти обучение по программе?
            </p>
            {activeField === 1 ? (
              <Minus className={styles.right_item_img} onClick={() => setActiveField(null)}/>
            ) : (
              <Plus className={styles.right_item_img} onClick={() => setActiveField(1)}/>
            )}
          </div>
          {activeField === 1 && (
            <>
              <p className={styles.answer}>
                На обучение по программе можно попасть, поступив в магистратуру на кафедру биотехнологии и промышленной фармации в РТУ МИРЭА.
              </p>
            </>
          )}
        </div>

        <div className={styles.right_item}>
          <div className={styles.right_item_questions}>
            <p
              onClick={() => (activeField ? setActiveField(null) : setActiveField(2))}
              className={
                activeField === 1 || activeField === 3 || activeField === 4 || activeField === 5
                  ? styles.questions_disable
                  : styles.questions
              }
            >
              Сколько длится обучение по программе?
            </p>
            {activeField === 2 ? (
              <Minus className={styles.right_item_img} onClick={() => setActiveField(null)}/>
            ) : (
              <Plus className={styles.right_item_img} onClick={() => setActiveField(2)}/>
            )}
          </div>
          {activeField === 2 && (
            <p className={styles.answer}>
              Программа рассчитана на 2 учебных года. По её результатам вы защитите квалификационную работу по
              приоритетным направлениям в биофармацевтике.
            </p>
          )}
        </div>

        <div>
          <div className={styles.right_item}>
            <div className={styles.right_item_questions}>
              <p
                onClick={() => (activeField ? setActiveField(null) : setActiveField(3))}
                className={
                  activeField === 2 || activeField === 1 || activeField === 4 || activeField === 5
                    ? styles.questions_disable
                    : styles.questions
                }
              >
                Где проходит обучение по программе?
              </p>
              {activeField === 3 ? (
                <Minus className={styles.right_item_img} onClick={() => setActiveField(null)}/>
              ) : (
                <Plus className={styles.right_item_img} onClick={() => setActiveField(3)}/>
              )}
            </div>
            {activeField === 3 && (
              <>
                <p className={styles.answer}>
                  Обучение по программе проходит на кафедре биотехнологии и промышленной фармации РТУ МИРЭА.<br/>
                  Адрес: пр-т Вернадского, д. 86, корпус С, этаж 4, лаборатория С-408.
                </p>
                <a
                  target='_blank'
                  href='https://yandex.ru/maps/213/moscow/?ll=37.474543%2C55.660496&mode=routes&rtext=~55.660496%2C37.474543&rtt=auto&ruri=~ymapsbm1%3A%2F%2Fgeo%3Fdata%3DCgg1NjY2MDU2OBJK0KDQvtGB0YHQuNGPLCDQnNC%2B0YHQutCy0LAsINC%2F0YDQvtGB0L%2FQtdC60YIg0JLQtdGA0L3QsNC00YHQutC%2B0LPQviwgODbRgTEiCg3u5RVCFVikXkI%3D&z=17.27'
                  className={styles.answer}
                >
                  Посмотреть маршрут <span>&rarr;</span>
                </a>
              </>
            )}
          </div>
          <div className={styles.right_item}>
            <div className={styles.right_item_questions}>
              <p
                onClick={() => (activeField ? setActiveField(null) : setActiveField(4))}
                className={
                  activeField === 2 || activeField === 3 || activeField === 1 || activeField === 5
                    ? styles.questions_disable
                    : styles.questions
                }
              >
                Можно ли прийти на экскурсию в лабораторию?
              </p>
              {activeField === 4 ? (
                <Minus className={styles.right_item_img} onClick={() => setActiveField(null)}/>
              ) : (
                <Plus className={styles.right_item_img} onClick={() => setActiveField(4)}/>
              )}
            </div>
            {activeField === 4 && (
              <>
                <p className={styles.answer}>
                  Экскурсии в лаборатории проводятся в первый понедельник каждого месяца. Требуется предварительная запись через почту <a href="mailto:talent@generium.ru">talent@generium.ru</a>.
                </p>
              </>
            )}
          </div>
          <div className={styles.right_item}>
            <div className={styles.right_item_questions}>
              <p
                onClick={() => (activeField ? setActiveField(null) : setActiveField(5))}
                className={
                  activeField === 2 || activeField === 3 || activeField === 1 || activeField === 4
                    ? styles.questions_disable
                    : styles.questions
                }
              >
                Кто читает лекции и проводит практические занятия?
              </p>
              {activeField === 5 ? (
                <Minus className={styles.right_item_img} onClick={() => setActiveField(null)}/>
              ) : (
                <Plus className={styles.right_item_img} onClick={() => setActiveField(5)}/>
              )}
            </div>
            {activeField === 5 && (
              <>
                <p className={styles.answer}>
                  В ходе обучения по программе вы получите знания от ведущих специалистов Generium.
                </p>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default AskAndQuestions
